import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";
import type { Controller } from "../lifecycle";

gsap.registerPlugin(ScrollTrigger);

export class SmoothScrollController implements Controller {
  private lenis?: Lenis;
  private ticker?: (time: number) => void;

  mount(root: ParentNode): void {
    if (
      !root.querySelector("[data-film-story]") ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    this.lenis = new Lenis({
      duration: 1.05,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 0.86,
      touchMultiplier: 1
    });

    this.lenis.on("scroll", ScrollTrigger.update);
    this.ticker = (time: number) => this.lenis?.raf(time * 1000);
    gsap.ticker.add(this.ticker);
    gsap.ticker.lagSmoothing(0);
  }

  destroy(): void {
    if (this.ticker) {
      gsap.ticker.remove(this.ticker);
    }
    this.lenis?.destroy();
    this.lenis = undefined;
    this.ticker = undefined;
  }
}
